import css from './graph.module.scss';

import { memo } from 'react';

import { TTimeRecord } from '../types';
import { TX, TY } from './type';

const Points = ({
  x,
  y,
  dataSorted,
}: {
  x: TX;
  y: TY;
  dataSorted: TTimeRecord[];
}) => (
  <g data-role="points">
    {dataSorted.map(item => (
      <circle
        cx={x(item.weeks)}
        cy={y(item.count)}
        key={`${item.count}x${item.weeks}`}
        className={css.point}
      >
        <title>
          week: {item.weeks === 0 ? 'this' : item.weeks}, cards: {item.count}
        </title>
      </circle>
    ))}
  </g>
);

export default memo(Points);
